import React from "react";
import singpassLogo from "../../pages/smart-lend-frontend/src/img/singpass_logo.png";
import applyButton from "./apply-with-singpass.svg";
import "./MyinfoBusiness.css";

export function BusinessSingpassButton({ onClick, disabled = false, apply = true }) {
  const action = apply ? "Apply" : "Continue";
  return (
    <button type="button" className="mib-singpass-button" onClick={onClick} disabled={disabled} aria-label={`${action} with Singpass`}>
      {apply ? <img className="mib-approved-button" src={applyButton} alt="Apply with Singpass" /> : <><span>Continue with</span><img src={singpassLogo} alt="Singpass" /></>}
    </button>
  );
}

export function BusinessPrerequisites() {
  const service = process.env.REACT_APP_MYINFO_BIZ_SERVICE_NAME || "SmartlendBiz";
  const organisation = process.env.REACT_APP_MYINFO_BIZ_ORGANISATION_NAME || "Smart Towkay Ventures Pte. Ltd.";
  return (
    <p className="mib-prerequisites">
      To use Myinfo Business, ensure you have a Corppass account and are assigned to '{service}' digital service by '{organisation}' for the entity you are applying for.
    </p>
  );
}

export default function BusinessEntry({ onStart, onManual }) {
  return (
    <section className="mib-entry" aria-label="Sync Myinfo Business with Singpass">
      <div className="mib-sync-heading">
        <span className="mib-sync-icon"><img src={singpassLogo} alt="" /></span>
        <div>
          <h2>Sync Myinfo Business <span>with</span> <b>Singpass</b></h2>
          <p className="mib-sync-subtitle">Auto-fill business details via Singpass for Corporate Loans.</p>
        </div>
      </div>
      <BusinessPrerequisites />
      <div className="mib-entry-actions">
        <BusinessSingpassButton onClick={onStart} />
        {onManual && <button type="button" className="mib-assistance" onClick={onManual}>Apply with assistance</button>}
      </div>
    </section>
  );
}

export function BusinessRetrievalError({ onRetry, onManual, onCancel }) {
  return (
    <section className="mib-error" role="alert">
      <span className="mib-eyebrow">Myinfo Business</span>
      <h2>We couldn't retrieve your details</h2>
      <p>The request may have been cancelled, expired, or the service may be unavailable. No retrieved information has been saved to your profile.</p>
      <p>Try again, check your Corppass digital service assignment, or enter your application details manually.</p>
      <div className="mib-entry-actions">
        {onRetry && <BusinessSingpassButton onClick={onRetry} />}
        {onManual && <button type="button" className="mib-secondary" onClick={onManual}>Apply with assistance</button>}
        {onCancel && <button type="button" className="mib-secondary" onClick={onCancel}>Cancel</button>}
      </div>
    </section>
  );
}
